import { render } from "./index.vue?vue&type=template&id=caf1abca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=caf1abca&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caf1abca"]])

export default __exports__